import { getItem, setItem } from './storage';

// UUID management utilities
export const USER_UUID_KEY = 'local_user_uuid';

/**
 * Generates a UUID v4 that matches format: 030ce5b4-0c81-4101-a10f-814ba852a15e
 * @returns {string} A UUID v4 string
 */
export function generateUUID() {
  // Standards-compliant UUID v4 generator
  // https://stackoverflow.com/a/2117523/6465432
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Ensures a UUID exists in localStorage, creating one if it doesn't or if it's invalid
 * @returns {string} The existing or newly created valid UUID
 */
export function ensureUserUUID() {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  let uuid = getItem(USER_UUID_KEY);
  if (!uuid || !uuidRegex.test(uuid)) {
    uuid = generateUUID();
    setItem(USER_UUID_KEY, uuid);
  }
  return uuid;
} 